/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import {FC, MouseEvent, ReactNode} from "react"
import {CSSTransition} from "react-transition-group"

import {TabletFrame} from "components/Layout"
import {CloseButton} from "components/button"
import cn from "classnames"
import ModalPortal from "./ModalPortal"

const transitionCn = {
  enter: "opacity-0",
  enterActive: "opacity-100",
  exit: "opacity-0"
}

interface Props {
  isOpened: boolean
  close: VoidFunction
  big?: boolean
  lockScroll?: boolean
  children: ReactNode
}

const ModalLayout: FC<Props> = ({big, isOpened, close, children, lockScroll}) => {
  const onFadeClick = (event: MouseEvent) => {
    if (event.target === event.currentTarget) {
      close()
    }
  }

  return (
    <ModalPortal>
      <CSSTransition timeout={150} in={isOpened} classNames={transitionCn} unmountOnExit>
        <div
          onClick={onFadeClick}
          className="fixed z-10 left-0 top-0 w-full h-full bg-modal-fade transition flex tablet:items-center tablet:justify-center"
        >
          <TabletFrame
            big={big}
            className={cn({
              relative: true,
              "tablet:overflow-y-hidden": lockScroll
            })}
          >
            <CloseButton className="absolute z-10 top-5 right-5" onClick={close} />
            {children}
          </TabletFrame>
        </div>
      </CSSTransition>
    </ModalPortal>
  )
}

export default ModalLayout
